<template>
  <section class="app-aproc">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-row v-if="certificado">
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <article class="certificate">
                <header class="certificate-header">
                  <v-icon>verified_user</v-icon>
                  <span>Validação de Certificado</span>
                </header>
                <section class="certificate-content">
                  <p>
                    <strong>Contribuinte:</strong>
                    <span>{{ certificado.contribuinte }}</span>
                  </p>
                  <p v-if="certificado.placa">
                    <strong>Placa:</strong>
                    <span>{{ certificado.placa }}</span>
                  </p>
                  <p>
                    <strong>Validade:</strong>
                    <span>{{ certificado.validade }}</span>
                  </p>
                  <p>
                    <strong>Código Validador:</strong>
                    <span>{{ certificado.hash }}</span>
                  </p>
                  <v-btn
                    outlined
                    color="#2f70b6"
                    class="mt-2"
                    small
                    @click="goToPageForm()"
                  >Nova Verificação</v-btn>
                </section>
              </article>
            </v-col>
          </v-row>
          <v-overlay :value="isLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import ValidaCertificadoService from "@/services/validaCertificado.service";

export default {
  //metaInfo: "Certificado - Central Serviços",
  data() {
    return {
      certificado: null,
      isLoading: false
    };
  },
  methods: {
    loadCertificado() {
      const { codigoValidador } = this.$route.params;
      this.isLoading = true;
      ValidaCertificadoService.validaCertificado(codigoValidador).subscribe(
        res => {
          this.certificado = res;
          this.isLoading = false;
        },
        error => {
          this.isLoading = false;
          this.$router.push({ name: "validacao-de-certificado" });
        }
      );
    },
    goToPageForm() {
      this.$router.push({ name: "validacao-de-certificado" });
    }
  },
  mounted() {
    this.loadCertificado();
  }
};
</script>

<style lang="scss" scoped>
.certificate {
  border: solid 1px #ededed;
  border-radius: 4px;
  width: 100%;
  margin: auto;
  background: #fff;
  border-bottom: solid 3px #2f70b6;
  span {
    margin-left: 5px;
  }
  &-header {
    padding: 10px;
    border-bottom: solid 1px #ededed;
    font-weight: bold;
    text-transform: uppercase;
    .v-icon {
      color: green;
    }
  }
  &-content {
    padding: 10px;
    p {
      text-transform: uppercase;
      margin: 10px 0px;
      font-weight: 300;
      strong {
        font-weight: bold;
      }
    }
  }
}
</style>
